import NetworkTag from './NetworkTag'
export default NetworkTag



// WEBPACK FOOTER //
// ./src/atoms/NetworkTag/index.js